module.exports = __webpack_public_path__ + "img/puzzle.6252de61.svg";